import React from "react";
import Overview from "components/atoms/Store/Overview/Index";
import { StyledStoreOverView } from "components/atoms/Store/Overview/Overview.styles";
const StoresOverview = () => {
  return (
    <>
      <StyledStoreOverView>
        <div className="header">
          <h2>Stores</h2>
          <p>Loream Ipsum Text is a simple Dummy Text</p>
        </div>
        <Overview />
      </StyledStoreOverView>
    </>
  );
};

export default StoresOverview;
